import { type StalenessLevel, stalenessLevel } from '@/utils/dateFormatters'
import type { TankPerspectiveLabels, TankReadingsOverviewRow } from './queries'

export type DataPerspective = 'internal' | 'gravitate' | 'partner'

/**
 * Get the appropriate perspective label-set from a row based on the
 * Data Format selection, falling back to internal when absent.
 */
export function getPerspectiveLabels(
  row: TankReadingsOverviewRow,
  perspective: DataPerspective,
): TankPerspectiveLabels {
  switch (perspective) {
    case 'gravitate':
      return row.gravitate ?? row.internal
    case 'partner':
      return row.partner ?? row.internal
    default:
      return row.internal
  }
}

/** Freshness status for a row, derived from received_at (or 'none' when no reading). */
export function statusForRow(row: TankReadingsOverviewRow): StalenessLevel {
  return stalenessLevel(row.reading?.received_at)
}
